<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="订单编号">
                <a-input @keyup.enter="handleQuery" v-model="queryParam.orderNo" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="用户手机号">
                <a-input v-model="queryParam.userPhone" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <!-- <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="租户编码">
                  <a-input v-model="queryParam.code" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
<template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="租户编码">
                  <a-input v-model="queryParam.code" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
<template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="信用代码">
                  <a-input v-model="queryParam.socialCreditCode" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
<template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="联系人">
                  <a-input v-model="queryParam.contacts" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
<template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="电话">
                  <a-input v-model="queryParam.mobile" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
<template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="状态">
                  <a-select placeholder="请选择" v-model="queryParam.status" style="width: 100%" allow-clear>
                    <a-select-option :value="0"> 正常 </a-select-option>
                    <a-select-option :value="1"> 异常关闭 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
<template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="租户类型">
                  <a-select placeholder="请选择" v-model="queryParam.type" style="width: 100%" allow-clear>
                    <a-select-option :value="1"> 厂商 </a-select-option>
                    <a-select-option :value="2"> 经销商 </a-select-option>
                    <a-select-option :value="3"> 分经销商 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
<template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="营业状态">
                  <a-select placeholder="请选择" v-model="queryParam.tradeStatus" style="width: 100%" allow-clear>
                    <a-select-option :value="0"> 营业中 </a-select-option>
                    <a-select-option :value="10"> 维修升级中 </a-select-option>
                    <a-select-option :value="60"> 暂停营业 </a-select-option>
                    <a-select-option :value="70"> 隐藏 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
<template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="省">
                  <a-input v-model="queryParam.province" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
<template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="市">
                  <a-input v-model="queryParam.city" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
<template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="区">
                  <a-input v-model="queryParam.area" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
<template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="时间范围">
                  <a-range-picker format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="onChange" />
                </a-form-item>
              </a-col>
            </template> -->
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!-- <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['abm-fix:model:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button
          type="primary"
          :disabled="single"
          @click="$refs.createForm.handleUpdate(undefined, ids)"
          v-hasPermi="['abm-fix:dev:edit']"
        >
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['abm-fix:model:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['abm-fix:dev:export']">
          <a-icon type="download" />导出
        </a-button> -->
        <table-setting :style="{ float: 'right' }" :table-size.sync="tableSize" v-model="columns"
          :refresh-loading="loading" @refresh="getList" />
      </div>
      <Detail ref="Detail"></Detail>
      <!-- 增加修改 -->
      <create-form ref="createForm" :statusOptions="dict.type['sys_enable_disable']" @ok="getList" />
      <!-- 数据展示 -->
      <a-table :loading="loading" :size="tableSize" rowKey="id" :columns="columns" :data-source="list"
        :pagination="false" :bordered="tableBordered">
        <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status" />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="dvyTime" slot-scope="text, record">
          {{ parseTime(record.dvyTime) }}
        </span>
        <span slot="dvyType" slot-scope="text, record">
          {{
            record.dvyType == 1 ? '快递' : record.dvyType == 2 ? '自提' : record.dvyType == 3 ? '无需快递' : '同城配送'
          }}
        </span>
        <span slot="status" slot-scope="text, record">
          {{
            record.status == 1
              ? '待付款'
              : record.status == 2
                ? '待发货'
                : record.status == 3
                  ? '待收货'
                  : record.status == 4
                    ? '已完成'
                    : '成功'
          }}
        </span>
        <div slot="pic" slot-scope="text, record">
          <!-- <div v-viewer>
            <img :src="$url + record.pic" alt="" v-if="form.pic" />
          </div> -->
          <!-- 121212 -->
          <!-- {{ parseTime(record.createTime) }} -->
          <!-- {{ record.pic }} -->
          <div v-viewer>
            <img :src="$url + record.pic" alt="" style="width: 50px; height: 50px" />
          </div>
        </div>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['abm-integral:order:edit']"
            v-if="record.status == 2">
            发货
          </a>
          <a @click="handleDetail(record)" v-hasPermi="['abm-integral:order:query']">
            详情
          </a>
          <!-- <a-divider type="vertical" v-hasPermi="['abm-fix:model:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['abm-fix:model:remove']"> 删除 </a> -->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
        :total="total" :page-size="queryParam.pageSize" :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange" @change="changeSize" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { fetchList, delObj } from '@/api/pressure/integralOrder'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import Detail from './modules/detail.vue'
export default {
  name: 'Post',
  components: {
    CreateForm,
    Detail,
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  props: {
    isOperate: {
      type: Boolean,
      default: true,
    },
    prodId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      },
      columns: [
        {
          title: '用户名称',
          dataIndex: 'userName',
          align: 'center',
          width: '5%',
        },
        {
          title: '用户手机号',
          dataIndex: 'userPhone',
          width: '5%',
          align: 'center',
        },
        // {
        //   title: '账号类型',
        //   dataIndex: 'pic',
        //   scopedSlots: { customRender: 'pic' },
        //   align: 'center',
        // },
        {
          title: '订单编号',
          dataIndex: 'orderNo',
          width: '5%',
          align: 'center',
        },
        {
          title: '收货人姓名',
          dataIndex: 'receiverName',
          width: '5%',
          align: 'center',
        },
        {
          title: '收货人电话',
          dataIndex: 'receiverMobile',
          width: '5%',
          align: 'center',
        },

        {
          title: '商品总数',
          dataIndex: 'productNums',
          width: '5%',
          align: 'center',
        },
        {
          title: '配送类型',
          dataIndex: 'dvyType',
          width: '5%',
          scopedSlots: { customRender: 'dvyType' },
          align: 'center',
        },
        {
          title: '发货时间',
          dataIndex: 'dvyTime',
          width: '5%',
          scopedSlots: { customRender: 'dvyTime' },
          align: 'center',
        },
        {
          title: '物流单号',
          dataIndex: 'dvyFlowId',
          width: '5%',
          align: 'center',
        },
        {
          title: '商品总积分',
          dataIndex: 'integralTotal',
          width: '5%',
          scopedSlots: { customRender: 'integralTotal' },
          align: 'center',
        },
        // {
        //   title: '排序',
        //   dataIndex: 'sort',
        //   align: 'center',
        // },
        // {
        //   title: '设备编号',
        //   dataIndex: 'devCode',
        //   ellipsis: true,
        //   align: 'center',
        // },
        // {
        //   title: '租户简称',
        //   dataIndex: 'referredName',
        //   align: 'center',
        // },
        // {
        //   title: '租户编码',
        //   dataIndex: 'code',
        //   align: 'center',
        // },
        {
          title: '状态',
          dataIndex: 'status',
          width: '5%',
          scopedSlots: { customRender: 'status' },
          align: 'center',
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: '5%',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '5%',
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '5%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    if (this.prodId) {
      this.queryParam.prodId = this.prodId
      this.columns.pop()
    }
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    /** 查询部门列表 */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    // 点击跳转详情
    handleDetail(record) {
      this.$nextTick(() => {
        this.$refs.Detail.init(record, 1)
      })
    },
    // 点击确定
    onChange(e) {
      console.log(e, '的点点滴滴')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      }
      this.queryParam.prodId = this.prodId
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      const postIds = row.id || this.ids
      console.log(postIds, 'postIdspostIds')
      if (row.id) {
        ids = [{ id: postIds }]
      } else {
        postIds.forEach((v) => {
          ids.push({ id: v })
        })
      }
      console.log(ids, '的点点滴滴')
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() { },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'system/post/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() { },
      })
    },
  },
}
</script>
